import * as React from "react";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { DialogContent, Stack } from "@mui/material";
import { SxProps, Theme } from "@mui/material";

type WcButtonVariantOverrides = "text" | "contained" | "outlined";



export const WcDialogContent = DialogContent;




type WcDialogProps = DialogProps & {
  open: boolean;
  children?: React.ReactNode;
  heading?: string;
  useFullWidth?: boolean;
  leftButtonHeading?: string;
  rightButtonHeading?: string;
  leftButtonVariant?:WcButtonVariantOverrides;
  rightButtonVariant?: WcButtonVariantOverrides;
  leftButtonHidden?: boolean;
  rightButtonHidden?: boolean;
  leftButtonDisabled?: boolean;
  rightButtonDisabled?: boolean;
  handleClosePressed?: () => void;
  handleCancel?: () => void;
  sx?: SxProps<Theme>;
};

export const WcDialog = (props: WcDialogProps) => {
  const {
    open,
    heading,
    handleClosePressed,
    handleCancel,
    children,
    leftButtonHeading,
    rightButtonHeading,
    leftButtonVariant = "text",
    rightButtonVariant = "contained",
    leftButtonDisabled = false,
    rightButtonDisabled = false,
    leftButtonHidden = false,
    rightButtonHidden = false,
    sx,
    ...others
  } = props;
  const [openDialog, setOpenDialog] = React.useState(open);

  React.useEffect(() => {
    setOpenDialog(open);
  }, [open]);

  const handleClose = () => {
    handleClosePressed();
  };

  const handleCancelPressed = () => {
    handleCancel();
  };

  return (
    <Stack id="WcDialog" sx={[...(Array.isArray(sx) ? sx : [sx])]}>
      <Dialog
        open={openDialog}
        onClose={handleCancelPressed}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        {...others}
      >
        <DialogTitle id="alert-dialog-title">{heading}</DialogTitle>
        <DialogContent>{children}</DialogContent>
        <DialogActions>
          {!leftButtonHidden && (
            <Button variant={leftButtonVariant} disabled={leftButtonDisabled} onClick={handleCancelPressed}>
              {leftButtonHeading}
            </Button>
          )}
          {!rightButtonHidden && (
            <Button variant={rightButtonVariant} disabled={rightButtonDisabled} onClick={handleClose}>
              {rightButtonHeading}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Stack>
  );
};
export default WcDialog;
